// Navigation utilities for route parsing and URL building

// Parse route and extract page info
export const parseRoute = (location) => {
  // Match /acc-123/ads-balance (account ads balance page)
  const accBalanceMatch = location.match(/\/acc-(\d+)\/ads-balance/);
  if (accBalanceMatch) {
    return {
      type: 'account-balance',
      data: { accountId: accBalanceMatch[1] },
      chatId: null
    };
  }

  // Match /accounts
  if (location.match(/\/accounts/)) {
    return {
      type: 'accounts',
      data: {},
      chatId: null
    };
  }

  // Match /settings
  if (location.match(/\/settings/)) {
    return {
      type: 'settings',
      data: {},
      chatId: null
    };
  }

  // Default to accounts
  return {
    type: 'accounts',
    data: {},
    chatId: null
  };
};

// Helper function to build URL from page object
export const buildUrlFromPage = (page) => {
  switch (page.type) {
    case 'accounts':
      return '/accounts';
    case 'account-balance':
      return `/acc-${page.data.accountId}/ads-balance`;
    case 'settings':
      return '/settings';
    default:
      return '/accounts';
  }
};

// Determines transition direction between pages
// Returns 'LTR' (left-to-right) or 'RTL' (right-to-left)
export const getTransitionDirection = (currentPage, isGoingBack, previousPage) => {
  // Define page hierarchy depth (lower = top level, higher = deeper)
  const pageDepth = {
    'accounts': 0,
    'settings': 0,
    'account-balance': 1,
  };

  const currentDepth = pageDepth[currentPage.type] || 0;
  const previousDepth = previousPage ? (pageDepth[previousPage.type] || 0) : 0;

  // If going back, always slide right (LTR)
  if (isGoingBack) {
    return 'LTR';
  }

  // If going forward:
  // - Going deeper (list → detail) = slide left (RTL - new page from right)
  // - Going shallower (detail → list) = slide right (LTR - new page from left)
  // - Same level = slide left (RTL)
  if (currentDepth > previousDepth) {
    return 'RTL'; // Going deeper
  } else if (currentDepth < previousDepth) {
    return 'LTR'; // Going shallower
  } else {
    return 'RTL'; // Same level, default forward
  }
};
